<template>
  <div id="input-period-slider">
    <div id=slider-container>
      <feather-icon
        class="arrow-left-icon range-adjust-button"
        icon="ArrowLeftCircleIcon"
        color="#2D9CDB"
        @click="adjustValue('minus')"
        svgClasses="w-5 h-5"
      />
      <feather-icon
        class="arrow-right-icon range-adjust-button"
        icon="ArrowRightCircleIcon"
        @click="adjustValue('plus')"
        svgClasses="w-5 h-5"
      />
      <!--
      <vue-slider
        v-model="value"
        :fixed="false"
        :min="0"
        :max="maxValue"
        :max-range="3600"
        :min-range="60"
        :marks="marks"
        :interval="60"
        :tooltip-formatter="formatter"
        @change="valueChange"
        :tooltip="'always'"
        :tooltip-placement="['top', 'bottom']"
      />
      -->
      <vue-slider
        v-model="value"
        :fixed="false"
        :min="0"
        :max="maxValue"
        :max-range="86400"
        :min-range="60"
        :marks="marks"
        :interval="60"
        :tooltip-formatter="formatter"
        @change="valueChange"
        :tooltip="'always'"
        :tooltip-placement="['top', 'bottom']"
      />
    </div>
  </div>
</template>

<script>
import SecureDataflowMixin from "@/mixins/SecureDataflowMixin";
import moment from "moment";
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/antd.css'

export default {
  name: "inputPeriodSlider",
  mixins: [SecureDataflowMixin],
  components: {
    VueSlider
  },
  props: ["minPeriod", "maxPeriod", "rangeSelector"],
  data() {
    return {
      value: [0, 300],
      maxValue: 86400,
      formatter: v => `${( '00' + Math.floor(v / 3600) ).slice( -2 )}:${( '00' + ((v % 3600) / 60)).slice( -2 )}`,
      marks: val => val % 3600 === 0 ? ({
        label: `${( '00' + Math.floor(val / 3600) ).slice( -2 )}:${( '00' + ((val % 3600) / 60)).slice( -2 )}`,
      }) : false,
      valueChange: (value) => {
        this.notifyValueChangeToParent(value)
      },
      startPeriod: null,
      endPeriod: null,
    }
  },
  methods: {
    notifyValueChangeToParent(value) {
      let adjustedValue = [...value]
      if (adjustedValue[1] == this.maxValue) adjustedValue[1]-- // 次の日にならないように1秒引く

      let startPeriod = moment("2000/01/01/00:00").add(adjustedValue[0], "seconds").unix() * 1000
      let endPeriod = moment("2000/01/01/00:00").add(adjustedValue[1], "seconds").unix() * 1000
      this.$emit('getPeriod', {"startPeriod": startPeriod, "endPeriod": endPeriod});
    },
    adjustValue(mode) {
      let secondsFrom = this.value[0]
      let secondsTo = this.value[1]
      if (mode == 'plus') {
        const originalSecondsGap = secondsTo - secondsFrom
        const originalSecondsFrom = secondsFrom
        if (secondsFrom == this.maxValue) {
          // fromが限界値にあったら何もしない
        } else if (secondsFrom % 600 == 0) {
          // fromがちょうど10分刻みの点にあれば10分後の点に移動する
          secondsFrom = secondsFrom + 600
        } else {
          // fromがちょうど10分刻みの点になければ次の10分刻みの点に移動する
          secondsFrom = secondsFrom + (600 - secondsFrom % 600)
        }

        // toもfromと同じ動きをする
        if (secondsTo == this.maxValue) {
        } else if (secondsTo % 600 == 0) {
          secondsTo = secondsTo + 600
        } else {
          secondsTo = secondsTo + (600 - secondsTo % 600)
        }

        // toが限界以上まで移動してしまった場合に限界値まで調整
        if (secondsTo > this.maxValue) secondsTo = this.maxValue
        // 移動後のfromとtoの幅が移動前よりも狭ければfromを元の値に戻す
        if (secondsTo - secondsFrom < originalSecondsGap) secondsFrom = originalSecondsFrom
      } else {
        const originalSecondsGap = secondsTo - secondsFrom
        const originalSecondsTo = secondsTo
        if (secondsFrom == 0) {
        } else if (secondsFrom % 600 == 0) {
          secondsFrom = secondsFrom - 600
        } else {
          secondsFrom = secondsFrom - (secondsFrom % 600)
        }

        if (secondsTo == 0) {
        } else if (secondsTo % 600 == 0) {
          secondsTo = secondsTo - 600
        } else {
          secondsTo = secondsTo - (secondsTo % 600)
        }

        if (secondsTo - secondsFrom < originalSecondsGap) secondsTo = originalSecondsTo
      }
      this.value = [secondsFrom, secondsTo]
      this.notifyValueChangeToParent(this.value)
    },
    getPeriod(event) {
      this.startPeriod = event.min;
      this.endPeriod = event.max;
      this.$emit('getPeriod', {"startPeriod": this.startPeriod, "endPeriod": this.endPeriod});
    }
  },
  mounted() {
    let initialSecondsTo = moment().hours() * 60 * 60 + moment().minutes() * 60
    let initialSecondsFrom = initialSecondsTo - 60 * 60
    if (initialSecondsFrom < 0) initialSecondsFrom = 0
    this.value = [initialSecondsFrom, initialSecondsTo]
    this.notifyValueChangeToParent(this.value)
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/secure-dataflow/_variables.scss";

#input-period-slider {
  background-color: #21556F;
  color: $white;
  width: 100%;
  position: relative;
  .vue-slider-dot-tooltip-bottom {
    bottom: -30px;
  }
  .vue-slider-dot-tooltip-inner {
    border-color: $blue;
    background-color: $blue;
  }
  .range-adjust-button {
    color: $blue;
    position: absolute;
    cursor: pointer;
  }
  .arrow-left-icon {
    left: 0;
  }
  .arrow-right-icon {
    right: 0;
  }
  #slider-container {
    margin-top: 60px;
    margin-bottom: 90px;
    width: 93%;
    margin-left: auto;
    margin-right: auto;
  }
}
</style>
